import Vue from 'vue'
import mainVue from './main.vue'

const defaults = {
  files: [],
}

const MainConstructor = Vue.extend(mainVue)

let instance, currentBox

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })
}

const showBox = () => {
  if (!instance) {
    initInstance()
  }

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      let options = currentBox.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }

      instance.callback = currentBox.callback

      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      })
    }
  }
}

const QuestionImageUploadBox = function (options, callback) {
  if (Vue.prototype.$isServer) return
  if (options.callback && !callback) {
    callback = options.callback
  }

  currentBox = {
    options: _.merge({}, defaults, QuestionImageUploadBox.defaults, options),
    callback: callback,
  }

  showBox()
}

QuestionImageUploadBox.setDefaults = defaults => {
  QuestionImageUploadBox.defaults = defaults
}

QuestionImageUploadBox.open = (callback) => {
  return QuestionImageUploadBox({}, callback)
}

QuestionImageUploadBox.close = () => {
  instance.visible = false
  currentBox = null
}

QuestionImageUploadBox.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default QuestionImageUploadBox
export { QuestionImageUploadBox }



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-image-upload-box/src/main.js